import React from 'react';
import { useSystemModals } from '@src/hooks';
import LogHoursDialog from './LogHoursDialog';
import { useLocalTimeClock } from './useLocalTimeClock';
import { describeLoggedDuration, toLocalIsoDate } from './timeClockFormat';
import type { LogHoursConsultantOption } from './offeringHoursData';

// Opens Log hours for the running timer. The timer keeps running while the dialog is open
// and only stops once the hours are saved, so Cancel simply resumes tracking.
export const useTimerLogDialog = (): ( consultants?: LogHoursConsultantOption[] ) => void => {
    const modalActions                = useSystemModals(),
          { active, completeActive }  = useLocalTimeClock( { live: false } );

    return ( consultants?: LogHoursConsultantOption[] ) => {
        if( !active?.clientOfferingId ) return;

        const sessionId = active.id;
        const trackedMs = Math.max( 0, Date.now() - new Date( active.startedAt ).getTime() );
        const duration = describeLoggedDuration( trackedMs );

        modalActions.show(
            <LogHoursDialog
                clientOfferingId={ active.clientOfferingId }
                consultants={ consultants }
                prefill={ {
                    hours: duration.hours,
                    minutes: duration.minutes,
                    date: toLocalIsoDate( active.startedAt ),
                    trackedLabel: duration.trackedLabel,
                    startTime: active.startedAt,
                } }
                onSaved={ () => completeActive( sessionId, 'logged' ) }
                onClose={ () => modalActions.toggle( false ) }
            />,
            { size: 'small', centered: true }
        );
    };
};
